import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

// localStorage is safe here: consent value is a non-sensitive UI preference, not user data
const STORAGE_KEY = 'cookie-consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Small delay so it animates in after page load
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const setConsent = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-[1400px] mx-auto bg-zinc-950/95 backdrop-blur-md border border-tertiary rounded-xl shadow-2xl p-6 lg:p-8">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          {/* Text */}
          <div className="flex items-start gap-4 flex-1">
            <div className="hidden sm:flex w-10 h-10 shrink-0 rounded-full bg-gold/10 border border-gold/30 items-center justify-center">
              <Cookie className="w-5 h-5 text-gold" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-serif text-lg text-gold mb-1">We value your privacy</h3>
              <p className="text-sm text-secondary font-sans leading-relaxed">
                This site uses cookies to analyze traffic and serve personalized ads through Google
                AdSense. By clicking "Accept", you consent to our use of cookies. Read our{' '}
                <Link
                  to="/privacy-policy"
                  className="text-gold underline underline-offset-2 hover:opacity-70"
                  data-testid="cookie-privacy-link"
                >
                  Privacy Policy
                </Link>{' '}
                to learn more.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={() => setConsent('declined')}
              className="px-5 py-2.5 text-sm font-sans text-secondary border border-tertiary rounded-lg hover:text-white hover:border-secondary transition-colors"
              data-testid="cookie-decline-button"
            >
              Decline
            </button>
            <button
              onClick={() => setConsent('accepted')}
              className="px-6 py-2.5 text-sm font-sans font-medium text-black bg-gold rounded-lg hover:opacity-80 transition-opacity"
              data-testid="cookie-accept-button"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
